<template>
  <div class="content">
    <a-row>
      <a-col>
        <download-excel
          style="width: 100px"
          :data="data1"
          :fields="json_fields"
          :fetch="startDownload"
          type="xls"
          name="日志.xls"
        >
          <a-button class="buttonExport" type="primary">Excel导出</a-button>
        </download-excel>
       
        <a-table
          :scroll="{ x: 2000, y: 500 }"
          :columns="columns"
          :row-key="(item) => item.objId"
          :data-source="data"
          :pagination="pagination"
          :loading="loading"
          @change="handleTableChange"
        >
          <template slot="pic" slot-scope="name">
            <img :src="name" alt="" />
          </template>

   
          <template slot="operate" slot-scope="text, record">
            <a
              href=""
              v-on:click.prevent="
                topage(`/home/log/detail?id=${record.objId}`)
              "
              >详情</a
            >
          </template>
        </a-table></a-col
      >
    </a-row>
  </div>
</template>
<script>
import {userLogSeach} from "@/api/homeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    scopedSlots: { customRender: "objId" },
    align: "center",
    width: 30,
  },
  {
    title: "用户userId",
    dataIndex: "user_id",
    scopedSlots: { customRender: "user_id" },
    align: "center",
    width: 30,
  },
  {
    title: "商户号/id",
    dataIndex: "merchant_id",
    scopedSlots: { customRender: "merchant_id" },
    align: "center",
    width: 30,
  },
  {
    title: "门店号/id",
    dataIndex: "shop_id",
    scopedSlots: { customRender: "shop_id" },
    align: "center",
    width: 30,
  },
  {
    title: "日志信息",
    dataIndex: "description",
    width: 150,
    scopedSlots: { customRender: "description" },
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    scopedSlots: { customRender: "createTime" },
    align: "center",
    width: 50,
  },
//   {
//     title: "操作",
//     dataIndex: "operate",
//     width: 50,
//     fixed: "right",
//     scopedSlots: { customRender: "operate" },
//     align: "center",
//   },
];
export default {
  data() {
    return {
      uidPhone: "",
      data: [],
      data1: [],
      objId: "",
      json_fields: {
        编号: "objId",
        用户userid: "user_id",
        商户号: "merchant_id",
        门店号: "shop_id",
        日志信息: "description",
        创建时间: "createTime",
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      columnsMock: null,
      visible: false,
    };
  },
  props: ["formInline"],
  mounted() {
    this.queryData();
  },
  methods: {
    async startDownload(){
      // 构建查询参数，使用当前的筛选条件
      const data = {
            page_no: 1,
            page_size: 10,
            user_id: this.formInline.userId,
            merchant_id: this.formInline.merchantsId,
            shop_id: this.formInline.shopId,
            description: this.formInline.description,
        };
      
      // 第一步：获取总数量，判断数据规模
      const countRes = await userLogSeach(data);
      const totalCount = countRes.count || 0;
      
      if (totalCount === 0) {
        this.$message.warning('当前筛选条件下没有数据可导出');
        return [];
      }
      
      // 第二步：根据数据量决定获取策略
      let allData = [];
      
      if (totalCount <= 1000) {
        // 数据量较小，一次性获取
      
        const res = await userLogSeach({...data, page_no: 1, page_size: totalCount});
        allData = res.data || [];
      } else {
        // 数据量较大，分页获取
        const pageSize = 100;
        const totalPages = Math.ceil(totalCount / pageSize);
        
        // 提示用户正在获取数据
        const loadingMsg = this.$message.loading(`正在获取数据... 0/${totalPages}页`, 0);
        
        try {
          for (let page = 1; page <= totalPages; page++) {
            const res = await userLogSeach({...data, page_no: page, page_size: pageSize});
            if (res.data && res.data.length > 0) {
              allData = allData.concat(res.data);
            }
            // 更新进度提示
            loadingMsg();
            this.$message.loading(`正在获取数据... ${page}/${totalPages}页`, 0);
          }
        } finally {
          loadingMsg();
        }
      }
      
      this.$message.success(`成功获取 ${allData.length} 条数据，开始导出...`);
      return allData;
    },

    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      userLogSeach({page_no: this.pagination.current, page_size: this.pagination.pageSize}).then((res) => {
        this.data = res.data;
        this.pagination.total = res.count;
        console.log(res);
      });
      this.loading = false;
    },

    handleOk() {
        const data = {
            page_no: this.pagination.current,
            page_size: this.pagination.pageSize,
            user_id: this.formInline.userId,
            merchant_id: this.formInline.merchantsId,
            shop_id: this.formInline.shopId,
            description: this.formInline.description,
        };
      userLogSeach(data).then((res) => {
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
  
    // 查询
    queryData() {
      this.loading = true;
      userLogSeach({page_no: this.pagination.current, page_size: this.pagination.pageSize}).then(
        (res) => {
          console.log(res);
          this.loading = false;
          this.data = res.data;
          this.pagination.total = res.count;
          message.success(res.msg);
        }
      );
    },

  },
};
</script>

<style lang="scss" scoped>
.buttonExport {
  margin: 10px 0;
}
img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.content {
  padding: 0 20px;
  margin-top: 20px;
  background-color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/right/log/userLogContent.vue